import React from 'react';
import { Space } from 'antd';
import EditLabDiagnosticTestButton from './EditLabDiagnosticTestButton';

const ActionsColumn = ({ columnData, onUpdateLabTest, getDetailInfo }) => (
  <Space>
    <EditLabDiagnosticTestButton
      columnData={columnData}
      onUpdateLabTest={onUpdateLabTest}
      getDetailInfo={getDetailInfo}
    />
  </Space>
);
export default ActionsColumn;
